module.exports = __webpack_public_path__ + "img/Valoris_80X30.8fe85467.png";